import React, {
  MouseEventHandler,
  SyntheticEvent,
  useCallback,
  useState,
} from 'react';
import Img from 'react-cool-img';
import { useDispatch } from 'react-redux';
import { groupBy } from 'lodash';
import moment from 'moment';
import { Popover, PopoverProps } from '@mui/material';
import Close from 'spw-static/images/delete-input-icon.svg';
import { openFeedbackModal } from 'spw-redux/modules/feedback/actions';
import {
  Column,
  SPWIconButton,
  UnstyledLink,
} from 'spw-shared/globalComponents';
import useCheckFloorplanOperationBeforeCalling from 'spw-shared/hooks/use-check-selection-mode-before-calling';
import { AnnouncementsCard, HelpMenuItem, NewHelpButton } from './styles';
import releases from '../../releases';

const groupedReleases = groupBy(releases, (r) => r.date.substring(0, 7));

const Help = () => {
  const dispatch = useDispatch();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [announcementsAnchorEl, setAnnouncementsAnchorEl] = useState(null);

  const openMenu = Boolean(menuAnchorEl);
  const openAnnouncements = Boolean(announcementsAnchorEl);

  const handleOpenMenu = useCheckFloorplanOperationBeforeCalling(
    (e: SyntheticEvent) => {
      setMenuAnchorEl(e.target);
    }
  );

  const handleClickHelpButton = useCallback<MouseEventHandler>(
    (e) => {
      e.persist();

      handleOpenMenu(e);
    },
    [handleOpenMenu]
  );

  const handleCloseHelpMenu = useCallback(() => {
    setMenuAnchorEl(null);
  }, [setMenuAnchorEl]);

  const handleUserGuideButtonClick = useCallback(() => {
    setMenuAnchorEl(null);
  }, [setMenuAnchorEl]);

  const handleLeaveFeedbackButtonClick = useCallback(() => {
    dispatch(openFeedbackModal(true));
    setMenuAnchorEl(null);
  }, [dispatch, setMenuAnchorEl]);

  // const handleAnnouncementsButtonClick = useCallback(() => {
  //   setMenuAnchorEl(null);
  //   setAnnouncementsAnchorEl(menuAnchorEl);
  // }, [setAnnouncementsAnchorEl, menuAnchorEl]);

  const handleCloseAnnouncements = useCallback<
    PopoverProps['onClose'] | MouseEventHandler
  >(
    (_, reason) => {
      if (reason !== 'backdropClick') {
        setAnnouncementsAnchorEl(null);
      }
    },
    [setAnnouncementsAnchorEl]
  );

  return (
    <>
      <NewHelpButton
        className={openMenu ? 'pressed' : ''}
        src="/images/help-new.svg"
        onClick={handleClickHelpButton}
      />
      <Popover
        id="Help popover"
        open={openMenu}
        anchorEl={menuAnchorEl}
        onClose={handleCloseHelpMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disableScrollLock
        style={{ transform: 'translateY(6px)' }}
      >
        <Column>
          {/* Commented out because content is outdated */}
          {/* <HelpMenuItem onClick={handleUserGuideButtonClick}>
            <UnstyledLink href="/Getting_Started.pdf" target="_blank">
              Getting Started Guide
            </UnstyledLink>
          </HelpMenuItem>
          <HelpMenuItem onClick={handleUserGuideButtonClick}>
            <UnstyledLink href="/Floor_Plan_Upload_Guide.pdf" target="_blank">
              Floor Plan Upload Guide
            </UnstyledLink>
          </HelpMenuItem>
          <HelpMenuItem onClick={handlePracticeExercisesButtonClick}>
            <UnstyledLink
              href="/Practice_Exercise_for_Bldg_HC_SC_Detailed_Worksheets.pdf"
              target="_blank"
            >
              Practice Exercises
            </UnstyledLink>
          </HelpMenuItem> */}
          <HelpMenuItem onClick={handleUserGuideButtonClick}>
            <UnstyledLink href="/User_Guide.pdf" target="_blank">
              User Guides
            </UnstyledLink>
          </HelpMenuItem>
          {/* <HelpMenuItem onClick={handleAnnouncementsButtonClick}> */}
          {/*  Announcements */}
          {/* </HelpMenuItem> */}
          <HelpMenuItem onClick={handleLeaveFeedbackButtonClick}>
            Leave Feedback
          </HelpMenuItem>
        </Column>
      </Popover>
      <Popover
        id="Announcements popover"
        open={openAnnouncements}
        anchorEl={announcementsAnchorEl}
        onClose={handleCloseAnnouncements}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disableScrollLock
        style={{ transform: 'translateY(6px)' }}
        PaperProps={{
          style: {
            overflowY: 'hidden',
          },
        }}
      >
        <AnnouncementsCard>
          <div className="title">
            Announcements
            <SPWIconButton
              onClick={handleCloseAnnouncements as MouseEventHandler}
            >
              <Img src={Close} alt="close" />
            </SPWIconButton>
          </div>
          <div className="content">
            {Object.keys(groupedReleases).map((month) => {
              const releasesInMonth =
                groupedReleases[month as keyof typeof groupedReleases];

              return (
                <div key={month} className="release-group">
                  <div className="release-group-title">
                    {moment(month).format('MMMM YYYY')}
                  </div>
                  <div>
                    {releasesInMonth.map((r) => (
                      <div key={r.date} className="release-card">
                        <div className="release-card-title">{r.title}</div>
                        <ul>
                          {r.features.map((feature) => (
                            <li key={feature}>{feature}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </AnnouncementsCard>
      </Popover>
    </>
  );
};

export default Help;
